/**
 * String Template – a port from the PHP version (StringTemplate class).
 *
 * @class StringTemplate
 * @author EN GARDE
 * @version 1.1
 */

import _ from 'lodash';
import * as jsHelper from '../helpers/js.js';

/**
 * @constructor
 */
export default function StringTemplate(options) {
	var that = this;

	that.options = _.defaultsDeep(that.defaults, options);
	that.vars = {};
}

StringTemplate.prototype.defaults = {
	prefix: '{{',
	suffix: '}}'
};

/**
 * Removes all previously set variables.
 * @memberof StringTemplate
 */
StringTemplate.prototype.clearVars = function () {
	var that = this;

	that.vars = {};
};

/**
 * Adds a variable that should replace {{name}} in the template string.
 * @memberof StringTemplate
 * @param {string} name - Name to search for {{name}}.
 * @param {mixed} value - Value value to replace with.
 */
StringTemplate.prototype.setVar = function (name, value) {
	var that = this;

	that.vars[name] = value;
};

/**
 * Adds multiple variables at once.
 * @memberof StringTemplate
 * @param {object} data - Data name & value pairs.
 * @property {string} name search for {{name}}
 * @property {mixed} value value to replace with
 */
StringTemplate.prototype.setVars = function (data) {
	var that = this;

	if (_.isEmpty(data) || !_.isObject(data)) {
		return;
	}

	_.forEach(data, function(value, name) {
		that.setVar(name, value);
	});
};

/**
 * Returns a previously set variable.
 * @memberof StringTemplate
 * @param {string} name - Name search for {{name}}.
 */
StringTemplate.prototype.getVar = function (name) {
	var that = this;

	if (!_.isUndefined(that.vars[name])) {
		return that.vars[name];
	}
};

/**
 * Parses a template string and returns it with all variables replaced.
 * @memberof StringTemplate
 * @param {string} templateString
 */
StringTemplate.prototype.getParsedTemplateString = function (templateString) {
	var that = this;

	if (!_.isEmpty(that.vars) && _.isString(templateString)) {
		_.forEach(that.vars, function(value, name) {
			var regex =  new RegExp(jsHelper.pregQuote(that.options.prefix) + name + jsHelper.pregQuote(that.options.suffix), 'g');

			templateString = templateString.replace(regex, value);
		});
	}

	return templateString;
};
